// @generated by scripts/gen-licenses.mjs from SPDX 3.28.0.
// Do not edit — re-run the script instead.

export interface DatasetLicenseOption {
  /** SPDX identifier — the stored value. */
  id: string;
  /** Compact label shown in the picker. */
  label: string;
  /** Full SPDX title. */
  name: string;
  /** Canonical licence URL, verified at generation time. */
  url: string;
  /** Open Definition conformance. */
  open: boolean;
}

/** A licence outside the table, carrying its own name and URL. */
export const LICENSE_ID_OTHER = "other";

export const DATASET_LICENSES: readonly DatasetLicenseOption[] = [
  {
    id: "CC0-1.0",
    label: "CC0 1.0",
    name: "Creative Commons Zero v1.0 Universal",
    url: "https://creativecommons.org/publicdomain/zero/1.0/",
    open: true,
  },
  {
    id: "PDDL-1.0",
    label: "PDDL 1.0",
    name: "Open Data Commons Public Domain Dedication & License 1.0",
    url: "https://opendatacommons.org/licenses/pddl/1-0/",
    open: true,
  },
  {
    id: "CC-PDM-1.0",
    label: "Public Domain Mark 1.0",
    name: "Creative Commons Public Domain Mark 1.0 Universal",
    url: "https://creativecommons.org/publicdomain/mark/1.0/",
    open: true,
  },
  {
    id: "CC-BY-4.0",
    label: "CC BY 4.0",
    name: "Creative Commons Attribution 4.0 International",
    url: "https://creativecommons.org/licenses/by/4.0/",
    open: true,
  },
  {
    id: "CC-BY-SA-4.0",
    label: "CC BY-SA 4.0",
    name: "Creative Commons Attribution Share Alike 4.0 International",
    url: "https://creativecommons.org/licenses/by-sa/4.0/",
    open: true,
  },
  {
    id: "CC-BY-3.0",
    label: "CC BY 3.0",
    name: "Creative Commons Attribution 3.0 Unported",
    url: "https://creativecommons.org/licenses/by/3.0/",
    open: true,
  },
  {
    id: "CC-BY-SA-3.0",
    label: "CC BY-SA 3.0",
    name: "Creative Commons Attribution Share Alike 3.0 Unported",
    url: "https://creativecommons.org/licenses/by-sa/3.0/",
    open: true,
  },
  {
    id: "CC-BY-3.0-IGO",
    label: "CC BY 3.0 IGO",
    name: "Creative Commons Attribution 3.0 IGO",
    url: "https://creativecommons.org/licenses/by/3.0/igo/",
    open: true,
  },
  {
    id: "CC-BY-SA-3.0-IGO",
    label: "CC BY-SA 3.0 IGO",
    name: "Creative Commons Attribution-ShareAlike 3.0 IGO",
    url: "https://creativecommons.org/licenses/by-sa/3.0/igo/",
    open: true,
  },
  {
    id: "ODC-By-1.0",
    label: "ODC-By 1.0",
    name: "Open Data Commons Attribution License v1.0",
    url: "https://opendatacommons.org/licenses/by/1-0/",
    open: true,
  },
  {
    id: "ODbL-1.0",
    label: "ODbL 1.0",
    name: "Open Data Commons Open Database License v1.0",
    url: "https://opendatacommons.org/licenses/odbl/1-0/",
    open: true,
  },
  {
    id: "CDLA-Permissive-2.0",
    label: "CDLA-Permissive 2.0",
    name: "Community Data License Agreement Permissive 2.0",
    url: "https://cdla.dev/permissive-2-0/",
    open: true,
  },
  {
    id: "CDLA-Permissive-1.0",
    label: "CDLA-Permissive 1.0",
    name: "Community Data License Agreement Permissive 1.0",
    url: "https://cdla.dev/permissive-1-0/",
    open: true,
  },
  {
    id: "CDLA-Sharing-1.0",
    label: "CDLA-Sharing 1.0",
    name: "Community Data License Agreement Sharing 1.0",
    url: "https://cdla.dev/sharing-1-0/",
    open: true,
  },
  {
    id: "CC-BY-NC-4.0",
    label: "CC BY-NC 4.0",
    name: "Creative Commons Attribution Non Commercial 4.0 International",
    url: "https://creativecommons.org/licenses/by-nc/4.0/",
    open: false,
  },
  {
    id: "CC-BY-NC-SA-4.0",
    label: "CC BY-NC-SA 4.0",
    name: "Creative Commons Attribution Non Commercial Share Alike 4.0 International",
    url: "https://creativecommons.org/licenses/by-nc-sa/4.0/",
    open: false,
  },
  {
    id: "CC-BY-ND-4.0",
    label: "CC BY-ND 4.0",
    name: "Creative Commons Attribution No Derivatives 4.0 International",
    url: "https://creativecommons.org/licenses/by-nd/4.0/",
    open: false,
  },
  {
    id: "OGL-UK-3.0",
    label: "Open Government Licence 3.0",
    name: "Open Government Licence v3.0",
    url: "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    open: true,
  },
  {
    id: "MIT",
    label: "MIT",
    name: "MIT License",
    url: "https://opensource.org/license/mit",
    open: true,
  },
  {
    id: "Apache-2.0",
    label: "Apache 2.0",
    name: "Apache License 2.0",
    url: "https://www.apache.org/licenses/LICENSE-2.0",
    open: true,
  },
  {
    id: "DbCL-1.0",
    label: "DbCL 1.0",
    name: "Open Data Commons Database Contents License 1.0",
    url: "https://opendatacommons.org/licenses/dbcl/1-0/",
    open: true,
  },
];

export const licenseById = (id: string): DatasetLicenseOption | undefined =>
  DATASET_LICENSES.find((l) => l.id === id);
